import * as signalR from '@microsoft/signalr';
import envConfig from '../envConfig';

const HUB_PATH = 'hubs/live-fleet';

function buildHubUrl() {
  const base = envConfig.ApiUrl || '';
  return base.endsWith('/') ? `${base}${HUB_PATH}` : `${base}/${HUB_PATH}`;
}

export function createLiveFleetConnection({ onSnapshot, onError, onStatusChange } = {}) {
  // withCredentials must be false because the API CORS policy uses
  // AllowAnyOrigin(); browsers reject credentialed responses against `*`.
  const connection = new signalR.HubConnectionBuilder()
    .withUrl(buildHubUrl(), { withCredentials: false })
    .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
    .configureLogging(signalR.LogLevel.Warning)
    .build();

  if (onSnapshot) {
    connection.on('vehicleSnapshot', (snapshot) => {
      onSnapshot(Array.isArray(snapshot) ? snapshot : []);
    });
  }
  if (onStatusChange) {
    connection.onreconnecting(() => onStatusChange('reconnecting'));
    connection.onreconnected(() => onStatusChange('connected'));
    connection.onclose(() => onStatusChange('disconnected'));
  }

  connection
    .start()
    .then(() => onStatusChange && onStatusChange('connected'))
    .catch((err) => {
      if (onError) onError(err);
    });

  return connection;
}

export async function stopLiveFleetConnection(connection) {
  if (!connection) return;
  try {
    await connection.stop();
  } catch {
    // Ignore: hub may already be closed.
  }
}
